import(/* webpackMode: "eager" */ "/vercel/path0/apps/repetix/app/global-error.tsx");
